<template>
  <v-dialog v-bind:value="dialog" @click:outside="$emit('close')" v-on:input="$emit('close')" max-width="1200px">
    <v-card>
      <v-form v-on:submit.prevent="importar($event)">
        <v-card-title>
          <span class="headline">{{ modal_title }}</span>
        </v-card-title>

        <v-card-text style="min-height: 450px">
          <v-stepper v-model="step" class="elevation-0">
            <v-stepper-header style="background: #607d8b; color: white">
              <v-stepper-step :complete="step > 1" step="1"> <span class="text-white">Paso 1</span> </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step :complete="step > 2" step="2"> <span class="text-white">Paso 2</span> </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1">
                <div class="row justify-content-center">
                  <div class="col-md-5 pt-10">
                    <p class="fs-16">1) Descargue el archivo excel para carga masiva</p>

                    <v-btn color="primary" class="mb-4 text-center ml-4" small @click="downloadTemplate">Descargar</v-btn>

                    <p class="fs-16">2) Complete el excel con los datos de sus servicios</p>
                    <p class="fs-16">3) Importe el excel con los datos completos</p>

                    <v-file-input
                      class="mt-3"
                      accept=".xlsx"
                      label="Seleccionar excel"
                      v-model="excel"
                      hint="Solo admite archivos formato .xlsx (No admite formato .xls)"
                      persistent-hint
                    ></v-file-input>

                    <v-btn color="primary" class="mt-3 float-right" small @click="readExcel" :disabled="excel == null">Siguiente</v-btn>
                  </div>
                </div>
              </v-stepper-content>

              <v-stepper-content step="2">
                <div style="border: solid 1px #999">
                  <v-data-table
                    :headers="headers"
                    :items="list_bulk"
                    :search="search"
                    :loading="loading"
                    :options="pagination"
                    loading-text="Cargando... Por favor espere"
                    @pagination="updatePagination"
                    hide-default-footer
                  >
                    <template v-slot:item="{ item, index }">
                      <tr>
                        <td>{{ item.object.name }}</td>
                        <td>{{ item.object.sku }}</td>
                        <td>{{ item.object.iva_desc }}</td>
                        <td>{{ item.object.type_name }}</td>
                        <td>{{ item.object.category_name }}</td>
                        <td>{{ item.object.subcategory_name }}</td>
                        <td>{{ item.object.enabled ? 'SI' : 'NO' }}</td>
                        <td style="min-width: 200px" v-if="!item.loading && item.status == 1 && item.msg == '' && !item.status_create">
                          <i class="fa fa-check text-green"></i>
                        </td>
                        <td style="min-width: 200px" v-if="!item.loading && item.status == 1 && item.msg != '' && !item.status_create">
                          <span class="text-red">{{ item.msg }}</span>
                        </td>
                        <td style="min-width: 200px" v-if="!item.loading && item.status == 1 && item.status_create">
                          <span class="text-green">Importado</span>
                        </td>
                        <td style="min-width: 200px" v-if="!item.loading && item.status == 0">
                          Pendiente de procesado
                        </td>
                        <td style="min-width: 200px" v-if="item.loading">Procesando...</td>
                      </tr>
                    </template>
                    
                    <template v-slot:no-results>
                      <v-alert :value="true" color="error" icon="warning">
                        {{ "Busqueda sin resultados - " + search }}
                      </v-alert>
                    </template>
                  </v-data-table>
                </div>
                <v-btn small class="text-white mt-3 mb-2" @click="step = step - 1" v-if="step != 1" color="red"> Atras </v-btn>

                <div class="pt-0 mt-3">
                  <p style="color: #1976d2; float: left; margin-right: 30px; font-size: 16px; margin-bottom: 5px">Servicios pendientes de procesar: {{ getPendienteProcesar() }}</p>
                  <p class="text-green" style="float: left; margin-right: 30px; font-size: 16px; margin-bottom: 5px">Servicios procesados validos: {{ getProcesadosValidos() }}</p>
                  <p style="color: red; margin-bottom: 0px; font-size: 16px; margin-bottom: 5px">Servicios procesados invalidos: {{ getProcesadosNoValidos() }}</p>
                </div>
                <div class="row mt-1" v-if="loading_create">
                  <div class="col-md-12">
                    <v-progress-linear v-model="percent" color="blue-grey" style="height: 25px !important">
                      <strong>{{ Math.ceil(percent) }}%</strong>
                    </v-progress-linear>
                  </div>
                </div>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
          <!-- START FORM DIALOG -->
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="$emit('close')">Cerrar</v-btn>
          <v-btn v-if="formBtn != ''" text color="green" type="submit" :loading="loading_create" :disabled="list_bulk.length == 0"> Importar </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { formatUtils } from "@/libs/utils/formatUtils";
import Constant from "@/constants/sections";
import { generalService } from "@/libs/ws/generalService";
import readXlsxFile from "read-excel-file";
import ModalGenericMixin from "@/mixins/ModalGenericMixin.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";
import { productService } from "../../../libs/ws/productService";

export default {
  props: {
    modal_title: String,
    dialog: Boolean,
    service: Object,
    mainItem: Object,
    viewdIndex: Number,
    formBtn: String,
    open: Function,
    close: Function,
    filter: Function,
    create: Function,
  },
  mixins: [ModalGenericMixin, ExportMixin],
  components: {},
  data() {
    return {
      formatUtils: formatUtils,
      step: 1,
      object: null,
      list_bulk: [],
      categories: [],
      subcategories: [],
      headers: [
        {
          text: "Nombre",
          align: "left",
          sortable: true,
          value: "name",
        },
        {
          text: "SKU",
          align: "left",
          sortable: true,
          value: "sku",
        },
        {
          text: "IVA %",
          align: "left",
          sortable: true,
          value: "iva_desc",
        },
        {
          text: "Tipo",
          align: "left",
          sortable: true,
          value: "type_name",
        },
        {
          text: "Rubro",
          align: "left",
          sortable: true,
          value: "category_name",
        },
        {
          text: "Subrubro",
          align: "left",
          sortable: true,
          value: "subcategory_name",
        },
        {
          text: "Habilitado",
          align: "left",
          sortable: true,
          value: "enabled",
        },
        { text: "Resultado", value: "msg" },
      ],
      pagination: {
        page: 1,
        itemsPerPage: 15,
      },
      search: "",
      loading: false,
      excel: null,
      envios_no_validos: 0,
      envios_creados: 0,
      loading_create: false,
    };
  },
  computed: {
    percent: {
      get() {
        return ((this.getProcesadosValidos() + this.getProcesadosNoValidos()) * 100) / this.list_bulk.length;
      },
      set(value) {
        return value;
      },
    },
  },
  watch: {
    dialog() {
      this.errors.clear();
      this.$validator.reset();
      this.excel = null;
      this.loading_create = false;
      this.list_bulk = [];
      this.step = 1;
    },
  },
  mounted() {
    this.loadComboData();
  },
  methods: {
    getPendienteProcesar() {
      if (this.list_bulk.length == 0) {
        return 0;
      }
      return this.list_bulk.filter((element) => element.status === 0).length;
    },
    getProcesadosValidos() {
      if (this.list_bulk.length == 0) {
        return 0;
      }
      return this.list_bulk.filter((element) => element.status === 1 && element.status_create).length;
    },
    getProcesadosNoValidos() {
      if (this.list_bulk.length == 0) {
        return 0;
      }
      return this.list_bulk.filter((element) => element.status === 1 && !element.status_create).length;
    },
    loadComboData() {
      // Cargar categorías
      generalService.setSection(Constant.SECTION_CATEGORIES);
      generalService
        .filter({})
        .then((response) => {
          this.categories = response.result;
        })
        .catch((e) => {
          console.log("categories.filter error", e);
        });

      // Cargar subcategorías
      generalService.setSection(Constant.SECTION_SUBCATEGORIES);
      generalService
        .filter({})
        .then((response) => {
          this.subcategories = response.result;
        })
        .catch((e) => {
          console.log("subcategories.filter error", e);
        });
    },
    parseObject(element) {
      try {
        var object = Object.assign({}, {});
        object.name = element[0];
        object.sku = element[1] != null ? element[1].toString() : null;
        object.iva_desc = element[2] ? element[2].toString() : '';
        object.type_name = element[3] ? element[3].toString() : '';
        object.category_name = element[4];
        object.subcategory_name = element[5];
        object.enabled = element[8] != null ? (element[8].toString().toLowerCase() === 'si' || element[8].toString() === '1' || element[8] === true) : true;
        
        // Crear presentación única con precio y costo
        object.presentations_arr = [
          {
            name: element[0], // Mismo nombre que el servicio
            base_price: element[6] ? parseFloat(element[6]) : 0,
            cost: element[7] ? parseFloat(element[7]) : 0,
            sellable: true
          }
        ];
      } catch (e) {
        console.log(element);
        console.log(e);
      }
      return object;
    },
    readExcel() {
      this.step++;
      this.list_bulk = [];
      this.envios_no_validos = 0;
      this.envios_creados = 0;
      
      try {
        // Leer hoja única de servicios
        readXlsxFile(this.excel, { sheet: 1 }).then((rows) => {
          rows.forEach((element, index) => {
            if (index >= 1) {
              var obj = {
                object: this.parseObject(element),
                msg: "",
                status: 0,
                status_create: false,
                loading: false,
              };
              this.list_bulk.push(obj);
            }
          });
          
          if (this.list_bulk.length === 0) {
            this.$toast.warning("No se encontraron servicios válidos en el archivo", "Precaución");
          }
        });
      } catch (error) {
        console.log(error);
        this.$toast.error("Ocurrio un error al leer el archivo excel.", "Error");
      }
    },
    async importar() {
      var index = 0;
      this.loading_create = true;
      for (const element of this.list_bulk) {
        //sin mensaje entonces es valido para crear
        if (this.list_bulk[index].msg == "" && !this.list_bulk[index].status_create && this.list_bulk[index].status == 0) {
          this.list_bulk[index].loading = true;
          let result = await this.createItem(this.list_bulk[index].object);

          this.list_bulk[index].loading = false;
          this.list_bulk[index].status = 1;
          this.list_bulk[index].status_create = result.status;
          this.list_bulk[index].msg = this.parseErrorResultValidation(result);
          if (result.status) {
            this.envios_creados++;
          }
        }

        index++;
      }

      this.loading_create = false;

      if (this.list_bulk.length - this.envios_no_validos == this.envios_creados) {
        this.$toast.success("Se crearon " + this.envios_creados + " servicios correctamente.", "Ok");
        this.$emit("close");
        this.$emit("filter");
      } else {
        this.$toast.warning("Se crearon " + this.envios_creados + " servicios, pero " + (this.list_bulk.length - this.envios_no_validos - this.envios_creados) + " no se pudieron crear.", "Precaucion");
        this.$emit("filter");
      }
    },
    updatePagination(pagination) {
      this.pagination = pagination;
    },
    async createItem(item) {
      return productService.import_service_line_excel(item); 
    },
        
    downloadTemplate() {
      this.exportExcel("products/get-sample-excel-service", {}, "plantilla_importacion_servicios.xlsx");
    },
  },
};
</script>

<style scoped>
.v-stepper {
  box-shadow: none;
}
</style>
